import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';

export function useTaskNavigation() {
  const router = useRouter();
  const accountId = useMapGetter('getCurrentAccountId');

  const taskNotificationPath = task => {
    if (task.conversationId || task.conversation_id) {
      const conversationId = task.conversationId || task.conversation_id;
      return `/app/accounts/${accountId.value}/conversations/${conversationId}`;
    }
    const contactId = task.contact?.id || task.contactId || task.contact_id;
    return `/app/accounts/${accountId.value}/contacts/${contactId}`;
  };

  const openTask = task => {
    router.push(taskNotificationPath(task));
  };

  return { taskNotificationPath, openTask };
}
